var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-card",
    { staticClass: "asset_review_step", attrs: { flat: "" } },
    [
      _c("v-card-title", { staticClass: "pa-0" }, [
        _c("h4", [
          _vm._v("\n      " + _vm._s(_vm.campaign.AccessReviewTitle) + "\n    ")
        ])
      ]),
      _vm._v(" "),
      _vm.accessList.length === 0 && !_vm.allowAddingAccess
        ? _c(
            "v-card-text",
            { key: "no-access-to-review", staticClass: "px-0 pb-3" },
            [
              _c("p", { staticClass: "mb-0" }, [
                _vm._v("This asset has no access to review")
              ])
            ]
          )
        : _c(
            "v-card-text",
            {
              key: "has-access-to-review",
              staticClass: "pa-0",
              attrs: { id: "accessReviewCard" }
            },
            [
              _c("p", { staticClass: "mb-1" }, [
                _vm._v(
                  "\n      " + _vm._s(_vm.campaign.AccessReviewDesc) + "\n    "
                )
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "pb-2", attrs: { id: "accessList" } }, [
                _c(
                  "div",
                  { staticClass: "access-Table" },
                  [
                    _c("status-display-bar", {
                      attrs: { error: _vm.errorMessage, loading: _vm.isLoading }
                    }),
                    _vm._v(" "),
                    _c("sphere-table", {
                      ref: "accessTable",
                      attrs: {
                        "client-side": "",
                        "table-type": "actionable",
                        name: "AccessTable",
                        "data-items": _vm.accessListItems,
                        columns: _vm.accessReviewColumns[_vm.assetType.name],
                        "configurable-table-key":
                          "asset-review-step-access-" + _vm.assetType.name
                      },
                      on: { selectionchange: _vm.keepRetireSelectionChange },
                      scopedSlots: _vm._u(
                        [
                          {
                            key: "no-data",
                            fn: function() {
                              return [
                                _vm._v(" This asset has no access to review ")
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "warningTemplate",
                            fn: function(ref) {
                              var props = ref.props
                              return [
                                _c("td", { class: props.field.class }, [
                                  !_vm.accessLevels.includes(
                                    props.dataItem.value
                                  ) && props.dataItem.value != null
                                    ? _c(
                                        "div",
                                        {
                                          key: "invalid-access-level",
                                          staticClass: "warning--text"
                                        },
                                        [
                                          _c(
                                            "v-tooltip",
                                            {
                                              attrs: { top: "" },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "activator",
                                                    fn: function(ref) {
                                                      var on = ref.on
                                                      var attrs = ref.attrs
                                                      return [
                                                        _c(
                                                          "v-icon",
                                                          _vm._g(
                                                            _vm._b(
                                                              {
                                                                attrs: {
                                                                  small: "",
                                                                  color:
                                                                    "warning"
                                                                }
                                                              },
                                                              "v-icon",
                                                              attrs,
                                                              false
                                                            ),
                                                            on
                                                          ),
                                                          [
                                                            _vm._v(
                                                              "\n                      " +
                                                                _vm._s(
                                                                  _vm.SbIcons
                                                                    .status.warn
                                                                ) +
                                                                "\n                    "
                                                            )
                                                          ]
                                                        ),
                                                        _vm._v(
                                                          "\n                    " +
                                                            _vm._s(
                                                              props.dataItem
                                                                .value
                                                            ) +
                                                            "\n                  "
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                true
                                              )
                                            },
                                            [
                                              _vm._v(" "),
                                              _c("span", [
                                                _vm._v(
                                                  "Modify and Read Only are the only acceptable values.\n                    Please choose one."
                                                )
                                              ])
                                            ]
                                          )
                                        ],
                                        1
                                      )
                                    : _c("div", { key: "valid-access-level" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(props.dataItem.value) +
                                            "\n              "
                                        )
                                      ])
                                ])
                              ]
                            }
                          },
                          !_vm.readOnlyAccessReview
                            ? {
                                key: "keepRetireTemplate",
                                fn: function(ref) {
                                  var props = ref.props
                                  return [
                                    _c(
                                      "td",
                                      { class: props.field.class },
                                      [
                                        _c(
                                          "v-btn-toggle",
                                          {
                                            key:
                                              props.dataItem.stsGuid +
                                              props.dataItem.newValue,
                                            staticClass: "my-1",
                                            attrs: { mandatory: "" },
                                            on: {
                                              click: function($event) {
                                                $event.stopPropagation()
                                              }
                                            },
                                            model: {
                                              value: props.dataItem.newValue,
                                              callback: function($$v) {
                                                _vm.$set(
                                                  props.dataItem,
                                                  "newValue",
                                                  $$v
                                                )
                                              },
                                              expression:
                                                "props.dataItem.newValue"
                                            }
                                          },
                                          _vm._l(_vm.accessLevels, function(
                                            val,
                                            idx
                                          ) {
                                            return _c(
                                              "v-btn",
                                              {
                                                key: idx,
                                                staticClass: "sb_btn_solid",
                                                attrs: {
                                                  id: "accessLevel_" + idx,
                                                  value: val,
                                                  small: "",
                                                  title: _vm.accessTooltips[val]
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.updateAccess(
                                                      [props.dataItem],
                                                      val
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                  " +
                                                    _vm._s(val) +
                                                    "\n                "
                                                )
                                              ]
                                            )
                                          }),
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            : null,
                          {
                            key: "actionBtns",
                            fn: function() {
                              return [
                                _c(
                                  "v-layout",
                                  {
                                    staticClass: "full_width",
                                    attrs: {
                                      wrap: "",
                                      row: "",
                                      "text-xs-right": ""
                                    }
                                  },
                                  [
                                    _c(
                                      "v-flex",
                                      { attrs: { lg12: "" } },
                                      [
                                        !_vm.readOnlyAccessReview
                                          ? _c(
                                              "span",
                                              _vm._l(_vm.accessLevels, function(
                                                accessLevel,
                                                idx
                                              ) {
                                                return _c(
                                                  "v-btn",
                                                  {
                                                    key: idx,
                                                    staticClass: "sb_btn_solid",
                                                    attrs: {
                                                      id: "AccessLevel_" + idx,
                                                      outline: "",
                                                      color:
                                                        accessLevel == "Remove"
                                                          ? "error"
                                                          : "",
                                                      title:
                                                        _vm.accessTooltips[
                                                          accessLevel
                                                        ],
                                                      disabled:
                                                        _vm.selectedItems
                                                          .length === 0 ||
                                                        _vm.readOnlyAccessReview
                                                    },
                                                    on: {
                                                      click: function($event) {
                                                        return _vm.updateSelectedAccess(
                                                          _vm.selectedItems,
                                                          accessLevel
                                                        )
                                                      }
                                                    }
                                                  },
                                                  [
                                                    _vm._v(
                                                      "\n                    " +
                                                        _vm._s(accessLevel) +
                                                        "\n                  "
                                                    )
                                                  ]
                                                )
                                              }),
                                              1
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _vm.allowAddingAccess
                                          ? _c("user-select-dialog", {
                                              attrs: {
                                                id: "AddAccessBtn",
                                                "button-class":
                                                  "sb-btn-outline-neutral",
                                                disabled:
                                                  _vm.selectedItems.length >
                                                    0 ||
                                                  _vm.readOnlyAccessReview,
                                                "button-text": "Add Access",
                                                "button-color": "primary",
                                                "button-icon": "add",
                                                "body-text":
                                                  "To grant access to addition users, select them here to add them to the list, then select the level of access they should have",
                                                "require-selection": "",
                                                "asset-review-step": ""
                                              },
                                              on: {
                                                "selected-users":
                                                  _vm.addAccessForUsers
                                              }
                                            })
                                          : _vm._e()
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            },
                            proxy: true
                          },
                          {
                            key: "accessChangeReason",
                            fn: function(ref) {
                              var props = ref.props
                              return [
                                _c(
                                  "td",
                                  { class: props.field.class },
                                  [
                                    _c("v-text-field", {
                                      staticClass: "my-1",
                                      attrs: {
                                        disabled: !props.dataItem
                                          .isTextFieldEnabled,
                                        maxlength: "100",
                                        rules:
                                          props.dataItem.isTextFieldEnabled &&
                                          _vm.validateRules
                                            ? _vm.rules
                                            : [],
                                        counter: "",
                                        small: "",
                                        dense: ""
                                      },
                                      on: {
                                        input: function($event) {
                                          return _vm.UpdateRemoveReason([
                                            props.dataItem
                                          ])
                                        }
                                      },
                                      model: {
                                        value: props.dataItem.reason,
                                        callback: function($$v) {
                                          _vm.$set(
                                            props.dataItem,
                                            "reason",
                                            $$v
                                          )
                                        },
                                        expression: "props.dataItem.reason"
                                      }
                                    })
                                  ],
                                  1
                                )
                              ]
                            }
                          }
                        ],
                        null,
                        true
                      )
                    })
                  ],
                  1
                )
              ])
            ]
          ),
      _vm._v(" "),
      _c(
        "v-snackbar",
        {
          attrs: { top: "", color: "warning" },
          model: {
            value: _vm.snackbar,
            callback: function($$v) {
              _vm.snackbar = $$v
            },
            expression: "snackbar"
          }
        },
        [
          _c("v-icon", { attrs: { left: "" } }, [
            _vm._v("\n      " + _vm._s(_vm.SbIcons.status.warn) + "\n    ")
          ]),
          _vm._v("\n    " + _vm._s(_vm.snackbarMessage) + "\n  ")
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }